export default __webpack_public_path__ + "static/media/christie.0e0badda.png";